/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * @module Range
 */
/**
 * @class
 * Class representing Range
 */
export class Range {
  /**
   * @public
   * @constructor
   * Creates a range for given min and max values
   * @param {number} [minVal = -1] - The minimum value.
   * @param {number} [maxVal = -1] - The maximum value.
   * @returns An instance of a Range
   */
  constructor() {
    let minVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    let maxVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    this.minValue = minVal;
    this.maxValue = maxVal;
  }
}